import { render, staticRenderFns } from "./SideNavItem.vue?vue&type=template&id=91b7e002&scoped=true&"
import script from "./SideNavItem.vue?vue&type=script&lang=js&"
export * from "./SideNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SideNavItem.vue?vue&type=style&index=0&id=91b7e002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b7e002",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91b7e002')) {
      api.createRecord('91b7e002', component.options)
    } else {
      api.reload('91b7e002', component.options)
    }
    module.hot.accept("./SideNavItem.vue?vue&type=template&id=91b7e002&scoped=true&", function () {
      api.rerender('91b7e002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SideNavItem.vue"
export default component.exports